export default __webpack_public_path__ + "static/media/fortinet-hover.6ebbaf36.svg";